import React, { FC } from "react";
import { Confetti } from "../Confetti/Confetti";
import { ReactComponent as LogoCheckmark } from "../../assets/icons/logo-checkmark.svg";

export interface SuccessCheckProps {
  className?: string;
}

export const SuccessCheck: FC<SuccessCheckProps> = ({
  className = "",
}) => {
  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      <div className="absolute left-1/2 top-1/2 w-[48rem] h-[48rem] -translate-x-1/2 -translate-y-1/2 pointer-events-none" style={{ zIndex: 0 }}>
        <Confetti className="w-full h-full" />
      </div>
      <div className="relative flex items-center justify-center z-10">
        <LogoCheckmark/>
      </div>
    </div>
  );
};

export default SuccessCheck; 
